// กติกาตัดสินว่า "ผลอ่านนี้นับเป็นการยิงครั้งใหม่ไหม" — แยกไฟล์ไว้เพราะไม่พึ่งเบราว์เซอร์เลย
// (ทดสอบตรง ๆ ด้วย node ได้ ไม่ต้องมีกล้อง)

export const GLOBAL_LOCK_MS = 350;  // รับรายการแล้วล็อกลูปสั้น ๆ กันเด้งรัว
export const REARM_GAP_MS = 900;    // โค้ดเดิมต้องหายจากเฟรมนานเท่านี้ ถึงจะนับเป็น "ตั้งใจยิงซ้ำ"

/**
 * ผลอ่านนี้ควร "รับ" ไหม
 *
 * กติกา: ถือป้ายเดิมค้างในเฟรมนาน ๆ ต้องไม่บวกจำนวนเอง — ตัวชี้วัดว่า "ตั้งใจยิงซ้ำ"
 * คือโค้ดนั้น *หายไปจากเฟรม* แล้วกลับมา ไม่ใช่แค่เวลาผ่านไปครบ (ลูปอ่านได้ ~8 ครั้ง/วินาที
 * ถ้าใช้แค่เวลา ป้ายที่วางค้างจะกลายเป็น +1 ทุก ๆ ช่วงเวลาที่ตั้งไว้)
 *
 * @param state {{ seen:{text,at}, accepted:{text,at} }} — ผู้เรียกอัปเดต seen ทุกครั้งที่อ่านได้
 */
export function shouldAccept(state, text, now) {
  const { seen, accepted } = state;
  if (now - accepted.at < GLOBAL_LOCK_MS) return false;
  // โค้ดเดิมที่เพิ่งรับไป: รับซ้ำได้ต่อเมื่อมันหลุดเฟรมไปแล้วกลับมา
  if (text === accepted.text && seen.text === text && now - seen.at < REARM_GAP_MS) return false;
  return true;
}
